import { render, staticRenderFns } from "./CartUpSellBlock.vue?vue&type=template&id=55106ba6"
import script from "./CartUpSellBlock.vue?vue&type=script&lang=js"
export * from "./CartUpSellBlock.vue?vue&type=script&lang=js"
import style0 from "./CartUpSellBlock.vue?vue&type=style&index=0&id=55106ba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports